import {
	HttpEvent,
	HttpHandlerFn,
	HttpInterceptorFn,
	HttpRequest,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { finalize, Observable } from "rxjs";
import { LoadingService } from "../../services/loading/loading.service";

let totalRequests = 0;

export const loadingInterceptor: HttpInterceptorFn = (
	req: HttpRequest<unknown>,
	next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
	const loadingService = inject(LoadingService);

	totalRequests++;
	loadingService.show();

	return next(req).pipe(
		finalize(() => {
			totalRequests--;
			if (totalRequests === 0) {
				loadingService.hide();
			}
		}),
	);
};
